import { useState, useEffect } from "react";
import { SensorCSVRow } from "features/iot/sensors/models/sensor-models";
import SensorCSVReader from "./sensor-csv-reader";

export const useCSVImport = () => {
  const [selectedCSV, setSelectedCSV] = useState<File | null>(null);
  const [sensorListDto, setSensorListDto] = useState<SensorCSVRow[]>([]);
  const [isError, setIsError] = useState<{
    isError: boolean;
    errorMessage: string;
  }>({ isError: false, errorMessage: "" });

  useEffect(() => {
    if (selectedCSV) {
      fetchCSVData();
    }
  }, [selectedCSV]);

  const fetchCSVData = async () => {
    try {
      const sensorRows = await SensorCSVReader(selectedCSV as File);
      setSensorListDto(sensorRows);
    } catch (error) {
      clearCSV();
      setIsError({
        isError: true,
        errorMessage: "Error while parsing the CSV",
      });
    }
  };

  const clearCSV = (onClearCallback?: () => void) => {
    setSelectedCSV(null);
    setSensorListDto([]);

    if (onClearCallback) {
      onClearCallback();
    }
  };

  return {
    setSelectedCSV,
    selectedCSV,
    sensorListDto,
    isError,
    setIsError,
    clearCSV,
  };
};
